import React from 'react';

function MessageInfo(props) {
    return (
        <div className={`xs-loader-container ${props.hide?'hide':''} `}>
             <i className="fa fa-info-circle xs-error-icon"></i>
                    <span className="xs-error-message">{props.message}</span>
        </div>
    );
}

export default MessageInfo;